import { render } from "./notPage.vue?vue&type=template&id=c544c466&scoped=true"
const script = {}

import "./notPage.vue?vue&type=style&index=0&id=c544c466&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c544c466"]])

export default __exports__